import React from "react";
import { motion } from "framer-motion";
import { FlameIcon } from "lucide-react";
const SPOTS_LEFT = 7;
const FILLED_PERCENT = 93;
export function ScarcityBar() {
  return <div className="w-full rounded-2xl border border-red-200 bg-red-50 p-4" data-id="element-275" data-mp="2l4xs2rydc4kp">
      <div className="flex items-center justify-between gap-3 text-sm font-bold" data-id="element-276" data-mp="2l2tq4fk15fn2">
        <span className="flex items-center gap-1.5 text-red-700" data-id="element-277" data-mp="2q26ckz6zokp4">
          <FlameIcon className="h-4 w-4" aria-hidden="true" data-id="element-278" data-mp="2b6gvnfgnuxr9" />
          Only {SPOTS_LEFT} spots left at the launch price
        </span>
        <span className="text-red-700" data-id="element-279" data-mp="2g74pe8w9xsp6">{FILLED_PERCENT}%</span>
      </div>
      <div className="mt-2.5 h-3.5 w-full overflow-hidden rounded-full bg-red-100" role="progressbar" aria-valuenow={FILLED_PERCENT} aria-valuemin={0} aria-valuemax={100} aria-label="Launch price spots claimed" data-id="element-280" data-mp="2273kmicw214f">
        <motion.div className="h-full rounded-full bg-red-600" initial={{
        width: "40%"
      }} whileInView={{
        width: `${FILLED_PERCENT}%`
      }} viewport={{
        once: true
      }} transition={{
        duration: 1.1,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-281" data-mp="5didv525sbl0" />
      </div>
      <p className="mt-2 text-xs text-red-800" data-id="element-282" data-mp="3dcoftd3frc6a">When the spots run out, the price returns to its regular value.</p>
    </div>;
}